import React from 'react';
import { styled } from 'linaria/react';

import Image from '@jetshop/ui/Image';
import { theme } from '../../../Theme';

const GalleryWrapper = styled('div')`
  display: ${props => props.display};
  grid-template-columns: 1fr;
  grid-template-rows: 80% 20%;
  grid-column-gap: 1rem;
  grid-row-gap: 0rem;
  margin-bottom: -1rem;

  .hidden {
    display: none;
  }

  .thumbnails {
    grid-area: 2 / 1 / 3 / 2;
    height: 100%;
    width: 100%;
    overflow-x: scroll;
    display: flex;
    flex-direction: row;
    gap: 0.5rem;
    & > div {
      cursor: pointer;
      background: white;
      min-width: 150px;
      height: 0;
      padding-bottom: 0 !important;
      aspect-ratio: 1 / 1;
    }
  }
  .mainImage {
    padding-bottom: 80% !important;
    padding-top: 0% !important;
    grid-area: 1 / 1 / 2 / 2;
  }
`;

const Gallery = ({ product }) => {
  const [activeImage, setActiveImage] = React.useState(0);
  const images = product?.images ?? [];
  const singleImage = images.length === 1;
  const imageSizes = [1 / 4, 1 / 3, 1 / 2, 1 / 2];
  return (
    <GalleryWrapper display={singleImage ? 'flex' : 'grid'}>
      <div className={singleImage ? 'hidden' : 'thumbnails'}>
        {images.map((image, index) => (
          <Image
            key={image?.url}
            aspect="1:1"
            className={index === activeImage ? 'active' : ''}
            src={image.url}
            onClick={() => setActiveImage(index)}
            sizes={imageSizes}
            modifiedDate={image?.modifiedDate}
          />
        ))}
      </div>
      <Image
        className="mainImage"
        src={images[activeImage].url}
        aspect="1:1"
        sizes={imageSizes}
        modifiedDate={images[activeImage]?.modifiedDate}
      />
    </GalleryWrapper>
  );
};

export default Gallery;
